"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInterestsEndpoints = createInterestsEndpoints;
/**
 * İlgi etiketleri ve öneri döngüsü — ikisi aynı sinyal kümesinden beslenir.
 */
function createInterestsEndpoints(client) {
    return {
        interestTags: {
            search: (query) => client.call('/interest-tags', 'get', {
                query: query,
            }),
            /** Kategori → alt etiket ağacı (155 etikette gezinme). */
            taxonomy: () => client.call('/interest-tags/taxonomy', 'get', {}),
            suggest: (input) => client.call('/interest-tags/suggestions', 'post', { body: input }),
        },
        /**
         * Öneri motoru (Blok 9-1). Yanıttaki `reason` YAPILANDIRILMIŞTIR; istemci
         * cümleyi `reasonToText` + `createTranslator` ile kendi dilinde üretir ve
         * `ReasonBlock` ile basar. `score` alanı EKRANDA GÖSTERİLMEZ.
         */
        recommendations: {
            /**
             * `surface` verilirse sunucu listeyi `delivered` sayar ve yanıtta
             * `impressionToken` döner (Blok 1 · Story 2); verilmezse ölçüm yapılmaz.
             */
            events: (query = {}) => client.call('/recommendations/events', 'get', { query: query }),
            people: (eventId, query = {}) => client.call('/events/{eventId}/recommendations/people', 'get', {
                path: { eventId },
                query: query,
            }),
            /**
             * Gösterim / tıklama telemetrisi (Blok 1 · Story 2) — ATEŞLE-UNUT.
             * Gövde jeton + öğe + sonuç taşır; `accepted` yalnız denetim içindir.
             */
            recordTelemetry: (input) => client.call('/recommendations/telemetry', 'post', { body: input }),
            /**
             * Etkinlik ilgi sinyali (Story 10.2) — rıza yoksa sunucu sessizce yazmaz.
             * Gövde tipi artık OpenAPI'den gelir (Blok 9-3: `@ApiBody` eklendi,
             * 9-2'deki `as never` köprüsü kalktı).
             */
            recordInterestSignal: (eventId, input) => client.call('/events/{eventId}/interest-signals', 'post', {
                path: { eventId },
                body: input,
            }),
        },
    };
}
//# sourceMappingURL=interests.js.map